import { atom } from 'jotai';
import { IS_DEV_ENV } from '@/constants/env';

export type ScriptLoadState = {
  google: boolean;
  microsoft: boolean;
  apple: boolean;
  /** True when gapi and picker:client are loaded and gapi.client is initialized (for Drive Picker). */
  googleDrivePicker: boolean;
};

export const scriptLoadStateAtom = atom<ScriptLoadState>({
  google: false,
  microsoft: false,
  apple: false,
  googleDrivePicker: false,
});

if (IS_DEV_ENV) {
  scriptLoadStateAtom.debugLabel = 'scriptLoadStateAtom';
}
